const threeColumnLeadership = {
  displayField: 'header',
  name: 'Three Column Leadership',
  description: 'This component will automatically query the leadership from the API.',
  fields: [
    {
      id: 'header',
      name: 'Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [
        { size: { min: null, max: 80 }, message: 'Max 80 Characters ' }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'people',
      name: 'People',
      type: 'Array',
      localized: false,
      required: true,
      validations: [],
      disabled: true,
      omitted: true,
      items: { type: 'Link', validations: [], linkType: 'Entry' }
    }
  ],
  sys: {
    id: 'threeColumnLeadership',
    version: 4,
    updatedAt: '2023-11-30T04:34:00.848Z'
  }
};
export default threeColumnLeadership;